import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getUser, logout } from "../actions/adminActions";
import Loading from "../helpers/Loading";
import Profile from "../components/UserAccount/Profile";
import Photo from "../components/UserAccount/Photo";
import Popup from "../helpers/Popup";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
const UserAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const [photo, setPhoto] = useState(null);
  const [theUser, setTheUser] = useState(null);
  useEffect(() => {
    (async function getUserData() {
      const user = await getUser();

      setTheUser(user);
    })();
  }, []);
  useEffect(() => {
    if (state?.message) {
      alertify.set("notifier", "position", "top-right");
      alertify.success(state?.message);
    }
  }, [state]);
  const handleLogout = async () => {
    await dispatch(logout(navigate));
  };
  if (theUser === null) return <Loading />;
  return (
    <>
      <Popup />
      <div className="user_account_container">
        {theUser.map((data) => {
          const { user, type, earnedPoints, _id, profile } = data;
          return (
            <React.Fragment key={_id}>
              <div className="user_profile_and_setting">
                {!profile ? (
                  <p className="avatar">{user.substr(0, 1)}</p>
                ) : (
                  <img
                    src={
                      photo
                        ? `${photo}`
                        : `https://drive.google.com/thumbnail?id=${profile}`
                    }
                    alt="photos"
                    className="avatar"
                  />
                )}
                <nav>
                  <Link to="/user/account">Profile</Link>
                  <Link to="/user/edit-photo">Photo</Link>
                  <a href="#NotAvailable">Account</a>
                  <a href="#NotAvailable">Payment Methods</a>
                  <a href="#logout" onClick={() => handleLogout()}>
                    Logout
                  </a>
                </nav>
              </div>
              <div className="user_profile_detail">
                <Routes>
                  <Route
                    path="/account"
                    element={
                      <Profile
                        earnedPoints={earnedPoints}
                        type={type}
                        user={user}
                      />
                    }
                  />
                  <Route
                    path="/edit-photo"
                    element={<Photo photo={photo} setPhoto={setPhoto} />}
                  />
                </Routes>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default UserAccount;
